import { StrictMode, Suspense, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as Sentry from '@sentry/react'
import { Auth0ProviderWithRedirectCallback } from './auth'
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import { CircularProgress, Box } from '@mui/material' // Add loading component

const root = ReactDOM.createRoot(document.getElementById('root'))
const domain =
  (process.env.REACT_APP_BUILD_ENV || 'development') === 'development' ?
    'dev-cfari9nt.au.auth0.com'
  : 'auth.qallix.com'

// Add loading fallback component
const SuspenseFallback = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <CircularProgress />
  </Box>
)

if ((process.env.REACT_APP_BUILD_ENV || 'development') !== 'development') {
  Sentry.init({
    dsn: 'https://6b536303dca64a71a3981924cf64c4f2@o1278486.ingest.sentry.io/4504275316310016',
    ignoreErrors: [/Network Error/i, /Login required/i],
    integrations: [
      new Sentry.browserTracingIntegration({
        routingInstrumentation: Sentry.reactRouterV6BrowserTracingIntegration(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
      Sentry.replayIntegration({
        maskAllInputs: false,
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  })
}

root.render(
  <StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithRedirectCallback
        domain={domain}
        clientId='kNYh6Tx7UbXCCf8VmiMM8kd7LmBitQZX'
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: 'https://qallix-api',
        }}
      >
        <Suspense fallback={<SuspenseFallback />}>
          <App />
        </Suspense>
      </Auth0ProviderWithRedirectCallback>
    </BrowserRouter>
  </StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()